<template>
  <div class="factioryAccount">
    <div class="section">
      <div class="search">
        <div class="searchLeft">
          <!-- 添加用户 -->
          <button class="button-solid button buttonDeviceJurisdiction" @click="creatcount">
            {{
            $t('account.createAccount') }}
            <span class="iconfont icon-add"></span>
          </button>
        </div>
        <div class="searchRight">
          <!-- 搜索 -->
          <div class="adminSearch">
            <el-input
              class="searchAll"
              v-model.trim="search.uid"
              :placeholder="$t('factory.ID')"
              clearable
            ></el-input>
            <el-input
              class="searchAll"
              v-model.trim="search.usr"
              :placeholder="$t('factory.acount')"
              clearable
            ></el-input>
            <!-- 搜索 -->
            <span class="search-device" @click="getAccountList(true)">{{ $t('recharge.Search') }}</span>
            <!-- 取消 -->
            <!-- <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span> -->
          </div>
        </div>
      </div>
      <el-table
        :data="accountList"
        stripe
        border
        height="100%"
        v-loading="loadingAccount"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        element-loading-spinner="el-icon-loading"
        class="tablemain tableloding"
        :empty-text="$t('account.nodata')"
        ref="multiplePnTable"
      >
        <el-table-column :label="this.$t('settingalarm.list')" fixed type="index" width="70"></el-table-column>
        <el-table-column prop="uid" :label="$t('factory.ID')" min-width="100px;" />
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="$t('factory.usrName')"
        >
          <template slot-scope="scope">
            <span class="redirect" @click="enterAccount(scope.row)" :title="scope.row.usr">
              {{ scope.row.usr
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="$t('basic.Mobile1')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.mobile">{{ scope.row.mobile || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="140px;"
          :show-overflow-tooltip="true"
          :label="$t('basic.Email1')"
        >
          <template slot-scope="scope">
            <span :title="scope.row.email">{{ scope.row.email || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ecoin" :label="$t('factory.ecoin')" />
        <el-table-column
          min-width="120px;"
          :show-overflow-tooltip="true"
          :label="$t('factory.acountType')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.role == '0'" :title="scope.row.role">{{ $t('role.plantOwner') }}</span>
            <span v-if="scope.row.role == '1'" :title="scope.row.role">{{ $t('role.manufacturer') }}</span>
            <span v-if="scope.row.role == '2'" :title="scope.row.role">{{ $t('role.distributor') }}</span>
            <span v-if="scope.row.role == '5'" :title="scope.row.role">{{ $t('role.viewer') }}</span>
            <span v-if="scope.row.role == '4'" :title="scope.row.role">{{ $t('role.group') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px;"
          :show-overflow-tooltip="true"
          :label="$t('factory.isEnabled')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enable == '1'">{{ $t('factory.enabled') }}</span>
            <span v-if="scope.row.enable == '0'">{{ $t('factory.disabled') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devcode" min-width="120px;" :label="$t('factory.code')" />
        <el-table-column
          min-width="160px;"
          prop="visibleDevcode"
          :label="$t('factory.visibleDevcode')"
        />
        <el-table-column min-width="160px;" :label="this.$t('account.createTime')">
          <template slot-scope="scope">
            <span :title="scope.row.gts">{{ scope.row.gts || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="this.$t('device.Operation')"
          width="160px"
          class="fixedRgiht"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              :title="$t('device.edit')"
              @click="editAccount(scope.row)"
            >
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button
              type="text"
              class="operation"
              :title="$t('device.delete')"
              @click="deleteAccount(scope.row)"
            >
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <div v-show="emptyText" slot="empty">
          <div style="line-height: 32px">{{ $t('account.nodata') }}</div>
        </div>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div class style="margin-left:10px;"></div>
        <!-- 分页 -->
        <el-pagination
          class="pagination"
          background
          @size-change="getAccountList(true)"
          @current-change="() => getAccountList()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 创建账号 -->
    <account-dialog
      :title="$t('account.createAccount')"
      :visible.sync="showCreatnewcountDialog"
      width="800px"
      :class="{ 'showDialog': showCreatnewcountDialog, 'hideDialog': !showCreatnewcountDialog }"
    >
      <el-form
        ref="creatForm"
        :model="form"
        slot="content"
        :rules="creatRules"
        label-position="right"
        label-width="80px"
      >
        <div class="form-title">1、{{ $t('factory.accountInfo') }}</div>
        <el-form-item prop="usr" :label="$t('factory.acount')">
          <div class="form-item">
            <el-input v-model="form.usr"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="pwd" :label="$t('factory.pwd')">
          <div class="form-item">
            <el-input v-model="form.pwd"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="comfirmPwd" :label="$t('factory.comfirmPwd')">
          <div class="form-item">
            <el-input v-model="form.comfirmPwd"></el-input>
          </div>
        </el-form-item>
        <div class="form-title">2、{{ $t('factory.factoryInfo') }}</div>
        <el-form-item prop="mobile" :label="$t('basic.Mobile1')">
          <div class="form-item">
            <el-input v-model="form.mobile"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="email" :label="$t('basic.Email1')">
          <div class="form-item">
            <el-input v-model="form.email"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="vcode" :label="$t('factory.code')">
          <div class="form-item">
            <el-select
              v-model="form.vcode"
              filterable
              multiple
              clearable
              :filter-method="filterVcode"
            >
              <el-option
                v-for="item in vcodeList"
                :key="item.code"
                :label="item.desc"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <!-- 客户名称 -->
        <el-form-item label="客户名称" prop="customerCode">
          <div class="form-item">
            <el-select
              v-model="form.customerCode"
              filterable
              multiple
              clearable
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :disabled="item.isChecked"
                :value="item.customerNumber"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="devcode" :label="$t('factory.devcode')">
          <div class="form-item">
            <el-select
              v-model="form.devcode"
              multiple
              filterable
              clearable
              :filter-method="filterDevcode"
            >
              <el-option
                v-for="item in devcodeList"
                :key="item.devcode"
                :label="item.descText"
                :value="item.devcode"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div></div>
      <div style="text-align:right;" slot="footer">
        <!-- <button class="button-hollow" @click="closeDialog">{{ $t('account.cancel') }}</button> -->
        <button type="button" class="btn btn-dark" @click="createNewAcount">
          {{ $t('account.submit')
          }}
        </button>
      </div>
    </account-dialog>

    <!--编辑用户 -->
    <account-dialog
      :title="$t('account.editUser')"
      :visible.sync="showEditcountDialog"
      width="800px"
      :class="{ 'showDialog': showEditcountDialog, 'hideDialog': !showEditcountDialog }"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        slot="content"
        :rules="editRules"
        label-position="right"
        label-width="95px"
      >
        <div class="form-title">1、{{ $t('factory.accountInfo') }}</div>
        <el-form-item prop="usr" :label="$t('factory.acount')">
          <div class="form-item">
            <el-input v-model="editForm.usr" disabled></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="pwd" :label="$t('account.newPwd')">
          <div class="form-item">
            <el-input v-model="editForm.pwd"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="comfirmPwd" :label="$t('account.confirmpassword')">
          <div class="form-item">
            <el-input v-model="editForm.comfirmPwd"></el-input>
          </div>
        </el-form-item>
        <div class="form-title">2、{{ $t('factory.factoryInfo') }}</div>
        <el-form-item prop="mobile" :label="$t('basic.Mobile1')">
          <div class="form-item">
            <el-input v-model="editForm.mobile"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="email" :label="$t('basic.Email1')">
          <div class="form-item">
            <el-input v-model="editForm.email"></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="enable" :label="$t('factory.isEnabled')">
          <div class="form-item">
            <el-radio v-model="editForm.enable" v-removeAriaHidden :label="true">{{ $t('browse.Enable') }}</el-radio>
            <el-radio v-model="editForm.enable" v-removeAriaHidden :label="false">{{ $t('browse.Disable') }}</el-radio>
          </div>
        </el-form-item>
        <el-form-item prop="vcode" :label="$t('factory.code')">
          <div class="form-item">
            <el-select
              v-model="editForm.vcode"
              filterable
              multiple
              clearable
              :filter-method="filterVcode"
            >
              <el-option
                v-for="item in vcodeList"
                :key="item.code"
                :label="item.desc"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <!-- 客户名称 -->
        <el-form-item label="客户名称" prop="customerCode">
          <div class="form-item">
            <el-select
              v-model="editForm.customerCode"
              filterable
              multiple
              clearable
         
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :disabled="item.isChecked"
                :value="item.customerNumber"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item prop="devcode" :label="$t('factory.devcode')">
          <div class="form-item">
            <el-select
              v-model="editForm.devcode"
              multiple
              filterable
              clearable
              :filter-method="filterDevcode"
            >
              <el-option
                v-for="item in devcodeList"
                :key="item.devcode"
                :label="item.descText"
                :value="item.devcode"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div></div>
      <div style="text-align:right;" slot="footer">
        <button type="button" class="btn btn-dark" @click="submitEditAccount">
          {{ $t('account.submit')
          }}
        </button>
      </div>
    </account-dialog>

    <!-- 删除用户 去掉弹框的heard不加title=""和footer noFooter -->
    <account-dialog
      :title="$t('account.deleteUser')"
      :visible.sync="showDeletecountDialog"
      :width="'450px'"
      :class="{ 'showDialog': showDeletecountDialog, 'hideDialog': !showDeletecountDialog }"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- ${this.$t("factory.confirmDelete")}"${row.usr}"${this.$t("factory.confirmDelete1")} -->
          <span class="contentdelete" style="width:100%;text-align:left;">
            <span style="color: rgba(255,204,102);">{{ $t("factory.confirmDelete") }}</span>
            <span style="color:red;">{{ deleteInfo.usr }}</span>
            <span style="color: rgba(255,204,102);">{{ $t("factory.confirmDelete1") }}</span>
          </span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;color:rgba(255, 255, 255, 0.7);">
            {{
            $t('account.notRecovered') }}
          </span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button
            type="button"
            class="btn btn-dark"
            style="margin-right:10px;"
            @click="confirmDelete"
          >
            {{
            $t('account.confirm') }}
          </button>
          <button type="button" class="btn btn-light" @click="showDeletecountDialog = false;">
            {{
            $t('account.cancel')
            }}
          </button>
        </div>
      </div>
    </account-dialog>
  </div>
</template>
<script>
// import { mapState } from "vuex";
// import filter from "@/assets/js/filter";
import accountDialog from "@/components/dialognew";
import encryption from "@/assets/js/encryption";
export default {
  components: {
    accountDialog
  },
  data() {
    //新增账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        //为空
        callback(new Error(this.$t("message.pwdAgain")));
      } 
      else if (value !== this.form.pwd) {
        //新增 密码不相同
        callback(new Error(this.$t("message.pwdNotsame")));
      } 
      callback();
    };
    //编辑账号的密码确认
    var validateconfEditPwd = (rule, value, callback) => {
      if (this.editForm.pwd&&!value) {
        //为空
        callback(new Error(this.$t("message.pwdAgain")));
      } 
      else if (value !== this.editForm.pwd) {
        //编辑 密码不相同
        callback(new Error(this.$t("message.pwdNotsame")));
      }
      callback();
    };
    var validatepwd = (rule, value, callback) => {
      var ref = /^[\w]{6,32}$/;
      if (!value) {
        callback(new Error(this.$t("message.pwd_is_required")));
      } else if (!ref.test(value)) {
        callback(new Error(this.$t("signup.pwdformat")));
      }
      callback();
    };
    return {
      emptyText: false,
      //搜索
      search: {
        uid: "",
        usr: ""
      },
      loadingAccount: false,
      //分页
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      },
      accountList: [], //表格数据
      showCreatnewcountDialog: false, //新增用户
      showEditcountDialog: false, //编辑用户
      showDeletecountDialog: false, //删除用户
      deleteInfo: "",
      //新增表单
      form: {
        usr: "",
        pwd: "",
        comfirmPwd: "",
        mobile: "",
        email: "",
        vcode: [],
        customerCode: [],
        devcode: []
      },
      // 编辑表单
      editForm: {
        usr: "",
        pwd: "",
        enable: true,
        comfirmPwd: "",
        mobile: "",
        email: "",
        vcode: [],
        customerCode: [],
        devcode: []
      },
      // 厂家编码
      vcodeList: [],
      // 客户列表
      customerList: [],
      // 厂家编码深拷贝备份，用于筛选
      vcodeBackup: [],
      // 设备编码
      devcodeList: [],
      // 设备编码深拷贝备份，用于筛选
      devcodeBackup: [],
      toFiles: [],
      //新建账号表单验证
      creatRules: {
        usr: [
          { required: true, message: this.$t("message.uname_is_required"), trigger: ["blur","change"] },
          {
            min: 2,
            max: 16,
            // pattern: /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/,
            // message: this.$t("signup.usrformat"),
            message: "账号长度2-16位",
            trigger: ["blur","change"]
          }
        ],
        pwd: [{ required: true, validator: validatepwd, trigger: ["blur","change"] }],
        comfirmPwd: [
          { required: true, validator: validateconfPwd, trigger: ["blur","change"] }
        ],
        vcode: [
          {
            required: true,
            trigger: ["blur","change"],
            message: this.$t("factory.prompt_codeTip")
          }
        ],
        customerCode: [
          {
            required: true,
            trigger: ["blur","change"],
            message: '客户名称不能为空'
          }
        ],
        devcode: [
          {
            required: true,
            trigger: ["blur","change"],
            message: this.$t("factory.devcode_is_requeired")
          }
        ],
        email: [
         {
            max:64,
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            // message: this.$t("account.title_info"),
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          }
        ],
        mobile: [
          {
            // pattern: /^1[3456789]\d{9}$/,
            min: 6,
            max: 32,
            // message: this.$t("account.title_info1"),
            message: this.$t("signup.mobileformat"),
            trigger: ["blur","change"]
          }
        ],
      },
      //编辑账号表单验证
      editRules: {
        usr: [
          { required: true, message: this.$t("message.uname_is_required"), trigger: ["blur","change"] },
          {
            min: 2,
            max: 16,
            // pattern: /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/,
            // message: this.$t("signup.usrformat"),
            message: "账号长度2-16位",
            trigger: ["blur","change"]
          }
        ],
        pwd: [
          {
            pattern: /^[\w]{6,32}$/,
            message: this.$t("signup.pwdformat"),
            trigger: ["blur","change"]
          }
        ],
        comfirmPwd: [
          { required: false, validator: validateconfEditPwd, trigger: ["blur","change"] }
        ],
        enable: [{ required: true,message: this.$t("factory.chooseIsEnabled"),trigger: ["blur","change"] }],
        vcode: [{ required: true, message: this.$t("factory.prompt_codeTip"),trigger: ["blur","change"] }],
        customerCode: [{ required: true, message: '客户名称不能为空',trigger: ["blur","change"] }],
        devcode: [{ required: true,message: this.$t("factory.devcode_is_requeired"), trigger: ["blur","change"]}],
        email: [
        {
            max:64,
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            // message: this.$t("account.title_info"),
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          }
        ],
        mobile: [
          {
            min: 6,
            max: 32,
            // message: this.$t("account.title_info1"),
            message: this.$t("signup.mobileformat"),
            trigger: ["blur","change"]
          }
        ],
      }
    };
  },
  computed: {
    // ...mapState({
    //   // 角色
    //   role: state => {
    //     return {
    //       id: state.user.role,
    //       name: filter.role(state.user.role).name,
    //       group: filter.role(state.user.role).group
    //     };
    //   }
    // })
  },
  watch: {},
  created() {
    this.getAccountList();
    this.getVcodeList();
    this.getDevcodeList();
    this.getCustomerList();
  },
  methods: {
    short2hex(val) {
      var __hexarr__ = new Array(
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F"
      );
      var hex = "";
      hex += __hexarr__[(val >>> 12) & 0x000f];
      hex += __hexarr__[(val >>> 8) & 0x000f];
      hex += __hexarr__[(val >>> 4) & 0x000f];
      hex += __hexarr__[val & 0x000f];
      return hex;
    },
    // 用户列表数据
    getAccountList(reset) {
      this.loadingAccount = true;
      if (reset) this.pagination.currentPage = 1;
      let params = {
        ...this.search,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize,
        i18n: this.$lang.currentLang,
        lang: this.$lang.currentLang,
        timezone: 8
      };
      this.$request
        .get("adminQueryVendorAccount", params)
        .then(res => {
          this.loadingAccount = false;
          if (res.err == 0) {
            this.accountList = res.dat.items.map(item => {
              item.devcode = item.vendor.vcode1.join(",");
              item.visibleDevcode = "";
              let vdevcode = item.vendor.devcode;
              for (let i = 0; i < vdevcode.length; i++) {
                if (i < vdevcode.length - 1) {
                  item.visibleDevcode += this.short2hex(vdevcode[i]) + ",";
                } else {
                  item.visibleDevcode += this.short2hex(vdevcode[i]);
                }
              }
              return item;
            });
            this.pagination.total = res.dat.totalCount;
          } else {
            this.emptyText = true;
            this.accountList = [];
            this.pagination.total = 0;
          }
        })
        .catch(err => {
          this.loadingAccount = false;
          this.emptyText = true;
          this.accountList = [];
          this.pagination.total = 0;
        });
    },
    //获取厂家编码下拉框
    getVcodeList() {
      this.$request
        .get("adminQueryVendorCode", {
          i18n: this.$lang.currentLang,
          lang: this.$lang.currentLang
        })
        .then(res => {
          if (res.err == 0) {
            this.vcodeList = res.dat;
            this.vcodeBackup = res.dat;
          } else {
            this.vcodeList = [];
          }
        });
    },
    //获取客户编码下拉框
    getCustomerList() {
      this.$request
        .getCRM("/crm/api/auth/web/getAllCustomers")
        .then(res => {
          console.log(res);
          if (res.code == 0) {
            this.customerList = res.data
          } else {
            this.customerList = [];
          }
        });
    },
    // 获取customerCode
    getCustomerCode(uid){
      let params = {
        uid:uid
      }
      this.$request
        .getPPR("/ppr/app/iotSysUser/pub/getCustomerCode",params)
        .then(res => {
          console.log(res);
          if (res.code == 0) {
            // this.editForm.customerCode = res.data
            this.$set(this.editForm, 'customerCode', res.data);
          } else {
            this.editForm.customerCode == []
          }
        });
    },
    //获取设备编码下拉框
    getDevcodeList() {
      this.$request
        .get("adminQueryDeviceCodes", {
          i18n: this.$lang.currentLang,
          lang: this.$lang.currentLang
        })
        .then(res => {
          if (res.err == 0) {
            this.devcodeList = res.dat.map(item => {
              item.descText =
                this.short2hex(item.devcode) + item.vendor + item.desc;
              return item;
            });
            this.devcodeBackup = JSON.parse(JSON.stringify(this.devcodeList));
          } else {
            this.devcodeList = [];
          }
        });
    },
    filterVcode(val) {
      if (val) {
        this.vcodeList = this.vcodeBackup.filter(item => {
          return item.desc.indexOf(val) != -1 || item.code.indexOf(val) != -1;
        });
      } else {
        this.vcodeList = JSON.parse(JSON.stringify(this.vcodeBackup));
      }
    },
    filterDevcode(val) {
      if (val) {
        this.devcodeList = this.devcodeBackup.filter(item => {
          return (
            item.descText.indexOf(val) != -1 ||
            String(item.devcode).indexOf(val) != -1
          );
        });
      } else {
        this.devcodeList = JSON.parse(JSON.stringify(this.devcodeBackup));
      }
    },
    //打开创建账号按钮
    creatcount() {
      this.$refs.creatForm.resetFields();
      this.getVcodeList();
      this.getDevcodeList();
      this.showCreatnewcountDialog = true;
    },
    createNewAcount() {
      console.log(this.$store.state);
      this.$refs.creatForm.validate(valid => {
        if (!valid) return false;
        let params = {
          ...this.form,
          pwd: encryption.byte2hex(
            encryption.rc4(
              encryption.sha1(this.form.pwd),
              this.$store.state.user.secret
            )
          ),
          vcode: this.form.vcode.join(","),
          vcodeName: this.form.vcode.map(id => this.vcodeList.find(item => item.code == id).desc || '').join(','),
          devcode: this.form.devcode.join(","),
          customerCode: this.form.customerCode.join(","),
          pprAuth: this.$store.state.user.pprAuth,
          i18n: this.$lang.currentLang,
          lang: this.$lang.currentLang
        };
        // console.log(this.form.vcode,this.form.vcode.map(id => this.vcodeList.find(item => item.code == id).desc).join(','),'78978948978978974');
        delete params.comfirmPwd;
        this.$request.get("adminAddVendorAccount", params).then(res => {
          if (res.err == 0) {
            this.showCreatnewcountDialog = false;
            this.$message.success(this.$t("account.createSuc"));
            this.getAccountList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    },
    //编辑账户
    editAccount(row) {
      this.$refs.editForm.resetFields();
      this.$refs.editForm.clearValidate();
      let params = {
        uid: row.uid,
        i18n: this.$lang.currentLang,
        lang: this.$lang.currentLang,
        timezone: 8
      };

      this.$request.get("adminQueryVendorAccount", params).then(res => {
        if (res.err == 0) {
          this.getVcodeList();
          this.getDevcodeList();
          this.getCustomerList();
         
          let info = res.dat.items[0];
          // let arr = [];
          // info.vendor.vcode.forEach(item => {
          //   this.vcodeList.forEach(val => {
          //     if (item == val.desc) {
          //       arr.push(val.code);
          //     }
          //   });
          // });
          this.editForm = {
            uid: info.uid,
            usr: info.usr,
            devcode: info.vendor.devcode,
            // vcode: arr,
            vcode: info.vendor.vcode1,

            email: info.email,
            mobile: info.mobile,
            enable: info.enable
          };
          this.getCustomerCode(row.uid)
          this.showEditcountDialog = true;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    //编辑账户提交
    submitEditAccount() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return false;
        let params = {
          ...this.editForm,
          pwd: this.editForm.pwd?encryption.byte2hex(
            encryption.rc4(
              encryption.sha1(this.editForm.pwd),
              this.$store.state.user.secret
            )
          ):"",
          vcode: this.editForm.vcode.join(","),
          devcode: this.editForm.devcode.join(","),
          customerCode: this.editForm.customerCode.join(","),
          i18n: this.$lang.currentLang,
          lang: this.$lang.currentLang
        };
        delete params.comfirmPwd;

        this.$request.get("adminEditVendorAccount", params).then(res => {
          if (res.err == 0) {
            this.showEditcountDialog = false;
            this.$message.success(this.$t("project.editSuc"));
            this.getAccountList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    },
    //删除用户
    deleteAccount(row) {
      this.deleteInfo = row;
      this.showDeletecountDialog = true;
    },
    // 确认删除
    confirmDelete() {
      this.$request
        .get("adminDelUsrInfo", {
          uid: this.deleteInfo.uid,
          i18n: this.$lang.currentLang,
          lang: this.$lang.currentLang
        })
        .then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("account.deleteSuc"));
            this.showDeletecountDialog = false;
            this.getAccountList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 跳转用户
    enterAccount(info) {
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.factioryAccount {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  // 时间图标
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 12px;
    left: -165px;
    height: 24px;
    width: 24px;
    background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  .redirect {
    color: @primaryTextColor;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      // align-self: flex-end;
      align-items: center;
      display: flex;
      justify-content: space-between;
      position: relative;

      .searchLeft {
        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222d35;
          border-radius: 0;

          span {
            padding-left: 5px;
          }
        }
      }

      .searchRight {
        display: flex;
        justify-content: flex-end;

        .adminSearch {
          display: flex;
          justify-content: flex-start;

          .searchAll {
            border-left: 1px solid #7b8395;

            /deep/.el-input__inner {
              width: 220px;
              padding-left: 10px;
            }
          }

          .search-device {
            display: inline-block;
            line-height: 48px;
            padding: 0 15px;
            width: 100%;
            font-size: 14px;
            background: #202d35;
            color: #33ffb6;
            cursor: pointer;

            &:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }
          }

          .search-hide {
            display: inline-block;
            // position: absolute;
            // right: -58px;
            // line-height: 48px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 15px;
            font-size: 14px;
            background: #202d35;
            color: #7b8395;
            border-left: 1px solid #7b8395;
            cursor: pointer;

            &:hover {
              background: @primaryColorTransparency30;
              color: rgb(255, 255, 255, 1);
            }
          }
        }
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 110px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px !important;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7b8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202d35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: "X";
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      //开关按钮
      .eb-switch {
        // 默认(false)
        &.el-switch {
          // Input
          // .el-switch__input {}
          // 轨道
          /deep/.el-switch__core {
            position: relative;
            vertical-align: middle;
            margin: 0;
            display: inline-block;
            width: 40px;
            height: 20px;
            outline: 0;
            border-radius: 10px;
            box-sizing: border-box;
            background-color: #666;
            border: 1px solid #666;
            cursor: pointer;
            transition: border-color 0.3s, background-color 0.3s;

            // transition: unset;
            // 开关把手
            &:after {
              content: "";
              width: 12px;
              height: 12px;
              top: 3px;
              left: 3px;
              box-sizing: border-box;
              background-color: #fff;
              border: 1px solid #fff;
              border-radius: 100%;
            }
          }
        }

        // 激活(true)
        &.el-switch.is-checked {
          // 轨道
          /deep/.el-switch__core {
            background-color: @primaryTextColor;
            border: 1px solid @primaryTextColor;

            // 开关把手
            &:after {
              content: "";
              left: 100%;
              margin-left: -16px;
              background-color: rgba(255, 255, 255, 1);
              border: 1px solid rgba(255, 255, 255, 1);
            }
          }
        }
      }

      .operation i {
        color: @primaryTextColor;
      }

      // /deep/.el-table--border::after,
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }

  /deep/.el-form-item {
    padding-left: 8%;
  }

  .form-item {
    width: 90%;
  }

  /deep/.el-select .el-tag {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    padding-right: 18px;
  }

  /deep/ .el-select .el-tag__close.el-icon-close {
    position: absolute;
    top: 25%;
    right: 0;
  }

  /deep/.el-select__input {
    width: 3%;
    margin-left: 5px;
  }

  /deep/.el-message-box {
    background: #222d35;
  }
}
</style>
